import React, { useState, useEffect } from 'react';
import { useSearchParams, useParams } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import guestTranslations from '@/i18n/guestTranslations';

const GuestPayment = () => {
  const { apartment } = useParams();
  const [params] = useSearchParams();
  const lang = params.get('lang') || 'en';
  const regId = params.get('registration_id');
  const t = guestTranslations[lang] || guestTranslations.en;
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(null);

  useEffect(() => {
    if (!regId) return;
    const API = process.env.REACT_APP_BACKEND_URL || '';
    fetch(`${API}/api/guest/registration/${regId}`)
      .then(r => r.json()).then(setData);
  }, [regId]); // eslint-disable-line react-hooks/exhaustive-deps

  const commission = data ? (data.commission ?? ((data.tax_amount * 0.03) + 0.30)) : 0;
  const totalAmount = data ? (data.total_amount ?? (data.tax_amount + commission)) : 0;

  const handlePay = async () => {
    setLoading(true);
    try {
      const API = process.env.REACT_APP_BACKEND_URL || '';
      const origin = window.location.origin;
      const res = await fetch(`${API}/api/guest/create-checkout`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ registration_id: regId, origin_url: origin }),
      });
      if (!res.ok) throw new Error('Checkout failed');
      const result = await res.json();
      if (result.url) window.location.href = result.url;
    } catch (err) {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-white" data-testid="payment-page">
      <meta name="robots" content="noindex, nofollow" />
      <div className="bg-[#65c3ba] text-white py-6 px-4">
        <div className="max-w-xl mx-auto">
          <h1 className="text-2xl font-bold" style={{fontFamily: "'Cabinet Grotesk', sans-serif"}}>{t.paymentTitle}</h1>
        </div>
      </div>
      <div className="max-w-xl mx-auto px-4 py-12">
        {data && (
          <div className="bg-[#F7F9F9] border border-[#E2E8F0] rounded-sm p-6 space-y-3 mb-8">
            <div className="flex justify-between text-[#0A1312]">
              <span>{t.totalTax}</span>
              <span className="font-medium">CHF {data.tax_amount.toFixed(2)}</span>
            </div>
            <div className="flex justify-between text-[#0A1312]">
              <span className="text-sm">{t.commission}</span>
              <span className="text-sm font-medium">CHF {commission.toFixed(2)}</span>
            </div>
            <div className="border-t-2 border-[#65c3ba] pt-3 flex justify-between text-[#0A1312]">
              <span className="text-lg font-bold">{t.totalPayment}</span>
              <span className="text-xl font-bold text-[#65c3ba]">CHF {totalAmount.toFixed(2)}</span>
            </div>
          </div>
        )}

        <p className="text-[#0A1312] mb-8 text-center">{t.paymentRedirect}</p>

        <Button onClick={handlePay} disabled={loading} data-testid="pay-now-btn"
          className="w-full bg-[#65c3ba] text-white hover:bg-[#3e716c] py-6 text-lg rounded-sm">
          {loading ? t.paymentProcessing : t.payNow}
        </Button>

        <p className="text-sm text-[#0A1312]/60 mt-8 text-center">{t.taxNote}</p>
      </div>
    </div>
  );
};

export default GuestPayment;
